module.exports = __webpack_public_path__ + "static/media/yves_legelard.050a3ebd.png";